"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _connectToStores = _interopRequireDefault(require("fluxible-addons-react/connectToStores"));

var _dialog = _interopRequireDefault(require("@audacious/components/lib/components/dialog"));

var _document = _interopRequireDefault(require("@audacious/components/lib/components/document"));

var _documentHeader = _interopRequireDefault(require("@audacious/components/lib/components/document/document-header"));

var _documentBody = _interopRequireDefault(require("@audacious/components/lib/components/document/document-body"));

var _documentFooter = _interopRequireDefault(require("@audacious/components/lib/components/document/document-footer"));

var _subHeading = _interopRequireDefault(require("@audacious/components/lib/components/typography/sub-heading"));

var _button = _interopRequireDefault(require("@audacious/components/lib/components/button"));

var _text = _interopRequireDefault(require("@audacious/components/lib/components/text"));

var _fileDrop = _interopRequireDefault(require("@audacious/components/lib/components/file-drop"));

var _linkButton = _interopRequireDefault(require("@audacious/components/lib/components/link-button"));

var _uploadPanelActions = require("../../../actions/uploadPanelActions");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function handleDownloadFile() {
  var headerString = '';
  var dataString = '';
  headerString += 'First Name,';
  headerString += 'Middle Name,';
  headerString += 'Last Name,';
  headerString += 'DOB,';
  headerString += 'Gender,';
  headerString += 'Address Line 1,';
  headerString += 'Address Line 2,';
  headerString += 'City,';
  headerString += 'State,';
  headerString += 'Zip Code,';
  headerString += 'Country Code,';
  headerString += 'Phone\n';
  dataString += 'Austin,';
  dataString += 'Chris,';
  dataString += 'Anderson,';
  dataString += '1/16/1980,';
  dataString += 'male,';
  dataString += '6520 Sint. Center,';
  dataString += 'Apt 2,';
  dataString += 'Houston,';
  dataString += 'TX,';
  dataString += '19263,';
  dataString += ',';
  dataString += '8607184530 \n';
  var link = document.createElement('a');
  link.href = "data:text/csv;charset=UTF-8,".concat(headerString + dataString);
  link.download = 'panel.csv';
  link.click();
}

var _ref =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_documentHeader.default, null, /*#__PURE__*/_react.default.createElement(_subHeading.default, {
  id: "upload-panel-drawer-header",
  level: "4"
}, "Upload New Panel"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_text.default, {
  size: "lg",
  weight: "semi-bold"
}, "1. Prepare CSV file for new Missing Persons Panel."));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement("div", {
  className: "drawer-instructions"
}, /*#__PURE__*/_react.default.createElement(_text.default, {
  size: "lg"
}, "Use the template to create a new Missing Persons Panel. Please be sure to include all required fields and to adhere to formatting rules."), /*#__PURE__*/_react.default.createElement(_linkButton.default, {
  color: "primary",
  variant: "opaque",
  textOnly: true,
  onClick: handleDownloadFile
}, "Download a template CSV file"));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement("div", {
  className: "upload-panel-drawer-section"
}, /*#__PURE__*/_react.default.createElement(_text.default, {
  size: "lg",
  weight: "semi-bold"
}, "2. Upload the CSV file."));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement("div", {
  className: "drawer-instructions"
}, /*#__PURE__*/_react.default.createElement(_text.default, {
  size: "lg"
}, "Uploading a new CSV file will overwrite the current panel, if one exists."));

var UploadPanelDrawer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UploadPanelDrawer, _React$Component);

  var _super = _createSuper(UploadPanelDrawer);

  function UploadPanelDrawer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UploadPanelDrawer);
    _this = _super.call(this, props);
    _this.handleFileSelect = _this.handleFileSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancelClick = _this.handleCancelClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UploadPanelDrawer, [{
    key: "handleFileSelect",
    value: function handleFileSelect(files) {
      var executeAction = this.context.executeAction;
      executeAction(_uploadPanelActions.importPanelFiles, files);
    }
  }, {
    key: "handleCancelClick",
    value: function handleCancelClick() {
      var executeAction = this.context.executeAction;
      var onClose = this.props.onClose;
      executeAction(_uploadPanelActions.clearImportPanelError);
      onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          importError = _this$props.importError;
      var fileMessages = importError ? {
        invalid: [importError]
      } : null;
      return /*#__PURE__*/_react.default.createElement(_dialog.default, {
        open: open,
        size: "sm",
        variant: "drawer-right",
        className: "upload-panel-drawer"
      }, /*#__PURE__*/_react.default.createElement(_document.default, {
        size: "sm"
      }, _ref, /*#__PURE__*/_react.default.createElement(_documentBody.default, null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/_react.default.createElement("div", {
        div: true,
        className: "upload-panel-drawer-section"
      }, /*#__PURE__*/_react.default.createElement(_fileDrop.default, {
        id: "upload-panel-file-drop",
        headerText: "",
        onFileSelect: this.handleFileSelect,
        messages: fileMessages,
        invalid: importError
      }))), /*#__PURE__*/_react.default.createElement(_documentFooter.default, null, /*#__PURE__*/_react.default.createElement(_button.default, {
        color: "primary",
        variant: "opaque",
        id: "upload-panel-drawer-cancel-button",
        onClick: this.handleCancelClick
      }, "Cancel"))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return UploadPanelDrawer;
}(_react.default.Component);

UploadPanelDrawer.contextTypes = {
  executeAction: _propTypes.default.func.isRequired,
  service: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])).isRequired
};

var _default = (0, _connectToStores.default)(UploadPanelDrawer, ['MissingPersonsStore'], function (context) {
  var missingPersonsStore = context.getStore('MissingPersonsStore');
  return {
    importError: missingPersonsStore.getImportedPanelError()
  };
});

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(handleDownloadFile, "handleDownloadFile", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/panels/upload-panel-drawer.jsx");
  reactHotLoader.register(UploadPanelDrawer, "UploadPanelDrawer", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/panels/upload-panel-drawer.jsx");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/panels/upload-panel-drawer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();